/*
 * DashboardHeader Messages
 *
 * This contains all the text for the DashboardHeader component.
 *
 */

import { defineMessages } from "utils/defineMessages";

export const scope = "app.components.DashboardHeader";

export default defineMessages(scope, {
  header: "This is the DashboardHeader component!",
  signout: "sign out",
  securitySettings: "security settings",
  username: "Username",
  email: "Email",
});
